import api from './api';

export interface Classe {
  id?: string;
  schoolId?: string;
  levelId: string;
  name: string;
  academicYear?: string;
  creationDatetime?: string;
}

export interface PageResponse<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface ClasseSearchFilters {
  name?: string;
  levelId?: string;
}

export interface ClasseSearchRequest {
  page?: number;
  size?: number;
  filters?: ClasseSearchFilters;
}

export const classeService = {
  getAllClasses: async (): Promise<Classe[]> => {
    const response = await api.get<Classe[]>('/{schoolId}/classes');
    return response.data;
  },

  searchClasses: async (request: ClasseSearchRequest = {}): Promise<PageResponse<Classe>> => {
    const searchRequest = {
      page: request.page ?? 0,
      size: request.size ?? 100,
      filters: request.filters || {},
    };

    const response = await api.post<PageResponse<Classe>>('/{schoolId}/classes/search', searchRequest);
    return response.data;
  },

  getClassesByLevel: async (levelId: string): Promise<Classe[]> => {
    const response = await api.get<Classe[]>(`/{schoolId}/classes/level/${levelId}`);
    return response.data;
  },

  getClasseById: async (id: string): Promise<Classe> => {
    const response = await api.get<Classe>(`/{schoolId}/classes/${id}`);
    return response.data;
  },

  createClasse: async (classe: Classe): Promise<Classe> => {
    const response = await api.post<Classe>('/{schoolId}/classes', classe);
    return response.data;
  },

  updateClasse: async (id: string, classe: Classe): Promise<Classe> => {
    const response = await api.put<Classe>(`/{schoolId}/classes/${id}`, classe);
    return response.data;
  },

  deleteClasse: async (id: string): Promise<void> => {
    await api.delete(`/{schoolId}/classes/${id}`);
  },
};

